import styled from 'styled-components';

export const BalanceLogsPageStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
    padding-bottom: var(--space-6);

    .page-header {
        display: flex;
        flex-direction: column;
        gap: var(--space-1);
        margin-bottom: var(--space-2);
    }

    .page-title {
        margin: 0;
        font-size: var(--font-size-h3);
        font-weight: 600;
        line-height: 1.25;
        color: var(--color-white-95);
    }

    .page-desc {
        margin: 0;
        font-size: var(--font-size-md);
        color: var(--text-color-secondary);
    }
`;

export const BalanceLogsSectionStyled = styled.section`
    padding: var(--space-5) var(--space-4);
    background: var(--color-surface);
    border-radius: var(--radius-md);

    .section-header {
        margin-bottom: var(--space-5);
    }

    .section-heading {
        display: flex;
        flex-direction: column;
        gap: var(--space-1);
        min-width: 0;
    }

    .section-title {
        margin: 0;
        font-size: var(--font-size-h4);
        font-weight: 600;
        color: var(--color-white-95);
    }

    .section-desc {
        margin: 0;
        font-size: var(--font-size-md);
        color: var(--text-color-secondary);
    }
`;

export const BalanceLogsTableWrapStyled = styled.div`
    overflow: auto;
    margin: 0 calc(-1 * var(--space-4));
    padding: 0 var(--space-4);
`;

export const BalanceLogsTableStyled = styled.table`
    width: 100%;
    min-width: 720px;
    border-collapse: collapse;
    background: var(--color-surface-secondary);
    border-radius: var(--radius-md);
    overflow: hidden;

    th,
    td {
        padding: 14px 16px;
        text-align: left;
        vertical-align: middle;
        white-space: nowrap;
    }

    th {
        font-size: var(--font-size-xs);
        font-weight: 400;
        color: var(--color-white-60);
        border-bottom: 1px solid var(--color-surface);
    }

    td {
        font-size: var(--font-size-md);
        font-weight: 400;
        color: var(--color-white-95);
        border-top: 1px solid var(--color-surface);
    }

    tbody tr:first-child td {
        border-top: none;
    }

    .col-muted {
        color: var(--color-white-60);
    }

    .col-amount {
        text-align: right;
        font-weight: 600;
    }

    .col-amount.positive {
        color: var(--color-success, #3dd68c);
    }

    .col-amount.negative {
        color: var(--color-danger, #f07178);
    }

    .col-reason {
        white-space: normal;
        max-width: 320px;
    }

    .empty-cell {
        padding: 32px 16px;
        text-align: center;
        color: var(--text-color-secondary);
        white-space: normal;
    }
`;

export const BalanceLogsLoadMoreStyled = styled.div`
    display: flex;
    justify-content: center;
    margin-top: var(--space-5);
`;
